module.exports = __webpack_public_path__ + "27c3c9b6bd2ec5d2ae4b62ced8b163a7.jpg";